import { CoachBloc as CoachBlocComponent } from './CoachBloc.component';
import { connector } from './CoachBloc.connector';

export const CoachBloc = connector(CoachBlocComponent);
